<template>
  <div class="chat-page-container">
    <!-- 独立返回按钮 -->
    <button class="home-btn" @click="goBack">
      <img src="@/image/home.png" alt="返回主页" class="home-icon">
    </button>
    
    <div class="chat-container">
      <!-- 聊天记录区域 -->
      <div class="chat-messages">
        <ChatMessage 
          v-for="(msg, index) in messages" 
          :key="index" 
          :content="msg.content" 
          :isUser="msg.isUser" 
          :file="msg.file"
        />
      </div>

      <!-- 卡片式输入区域 -->
      <div class="input-card">
        <!-- 可编辑的文本输入区域 -->
        <div 
          ref="editableDiv"
          class="editable-input"
          contenteditable="true"
          placeholder="输入消息..."
          @input="handleInput"
          @keydown="handleKeydown"
        ></div>
        
        <!-- 底部按钮区域 -->
        <div class="button-area">
          <button class="upload-btn" @click="triggerFileUpload">
            <img src="@/image/fileup.svg" alt="上传文件" class="btn-icon">
          </button>
          <button class="send-btn" @click="sendMessage">
            <img src="@/image/send.svg" alt="发送" class="btn-icon">
          </button>
        </div>
      </div>
      
      <!-- 隐藏的文件上传组件 -->
      <FileUploader 
        ref="fileUploader" 
        @fileSelected="handleFileUpload" 
        style="display: none"
      />
    </div>
  </div>
</template>

<script>
import ChatMessage from '@/components/ChatMessage.vue'
import FileUploader from '@/components/FileUploader.vue'

export default {
  components: { 
    ChatMessage, 
    FileUploader
  },
  data() {
    return {
      messages: [
        { content: "你好！我是AI助手，有什么可以帮你？", isUser: false, file: null }
      ],
      currentMessage: ''
    }
  },
  methods: {
    handleInput(event) {
      this.currentMessage = event.target.innerText.trim()
    },
    handleKeydown(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault()
        this.sendMessage()
      }
    },
    sendMessage() {
      const message = this.currentMessage.trim()
      if (message) {
        this.messages.push({ content: message, isUser: true, file: null })
        this.clearInput()
        
        // 模拟AI回复
        setTimeout(() => {
          this.messages.push({ content: `已收到：${message}`, isUser: false, file: null })
          this.scrollToBottom()
        }, 1000)
      }
    },
    clearInput() {
      this.$refs.editableDiv.innerText = ''
      this.currentMessage = ''
    },
    handleFileUpload(file) {
      this.messages.push({ 
        content: `上传了文件：${file.name}`, 
        isUser: true, 
        file 
      })
      setTimeout(() => {
        this.messages.push({ 
          content: `已处理文件：${file.name}（大小：${this.formatFileSize(file.size)}）`, 
          isUser: false, 
          file: null 
        })
        this.scrollToBottom()
      }, 1500)
    },
    formatFileSize(bytes) {
      if (bytes < 1024) return bytes + ' B'
      if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB'
      return (bytes / 1048576).toFixed(1) + ' MB'
    },
    triggerFileUpload() {
      this.$refs.fileUploader.triggerFileInput()
    },
    goBack() {
      this.$router.push('/')
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const messagesContainer = this.$el.querySelector('.chat-messages')
        if (messagesContainer) {
          messagesContainer.scrollTop = messagesContainer.scrollHeight
        }
      })
    }
  },
  mounted() {
    this.scrollToBottom()
  }
}
</script>

<style scoped>
.chat-page-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f5f5f5;
  position: relative;
}

.home-btn {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  transition: all 0.3s ease;
}

.home-btn:hover {
  background: #f8f9fa;
  transform: scale(1.05);
}

.home-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.chat-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
  padding-top: 80px; /* 为返回按钮留出空间 */
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 20px;
  padding: 0 15px;
  background: transparent;
}

/* 卡片式输入区域 */
.input-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  max-height: 200px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.editable-input {
  flex: 1;
  min-height: 60px;
  max-height: 150px;
  padding: 16px;
  border: none;
  outline: none;
  resize: none;
  font-size: 14px;
  line-height: 1.5;
  overflow-y: auto;
  background: transparent;
}

.editable-input:empty:before {
  content: attr(placeholder);
  color: #999;
}

.editable-input:focus {
  outline: none;
}

/* 按钮区域 */
.button-area {
  height: 15px;
  padding: 0 16px 16px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.upload-btn, .send-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.upload-btn:hover, .send-btn:hover {
  opacity: 0.7;
}

.btn-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 滚动条样式 */
.editable-input::-webkit-scrollbar {
  width: 4px;
}

.editable-input::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.editable-input::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.editable-input::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.chat-messages::-webkit-scrollbar {
  width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>